import { useFilters } from "../contexts/FilterContext";

export const useListingFilters = () => {
  const { filters } = useFilters();

  const filterListings = (listings) => {
    if (!listings || !Array.isArray(listings)) {
      return [];
    }

    return listings.filter((listing) => {
      // Search term filter (client-side — cheap)
      if (filters.searchTerm && filters.searchTerm.trim() !== "") {
        const searchLower = filters.searchTerm.toLowerCase();
        const matchesSearch =
          listing.title?.toLowerCase().includes(searchLower) ||
          listing.category?.name?.toLowerCase().includes(searchLower);

        if (!matchesSearch) return false;
      }

      // Category filter (client-side — cheap)
      if (filters.category && filters.category !== "") {
        const listingCategoryId = listing.category?._id || listing.category;
        if (listingCategoryId !== filters.category) {
          return false;
        }
      }

      // Location filter is now server-side. Listings arriving here are
      // already pre-filtered by lat/lng/radius if the location filter is on.

      return true;
    });
  };

  const sortListings = (listings) => {
    if (!listings || !Array.isArray(listings)) {
      return [];
    }

    const sorted = [...listings];

    switch (filters.sortBy) {
      case "newest":
        return sorted.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      case "oldest":
        return sorted.sort(
          (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
        );
      // NOTE: when location filter is active, the backend returns listings
      // pre-sorted by distance ($nearSphere). If the user picks "newest"
      // or "oldest", we override that. That's intentional — let users decide.
      default:
        return sorted;
    }
  };

  return {
    filters,
    filterListings,
    sortListings,
    applyFilters: (listings) => {
      const filtered = filterListings(listings);
      const sorted = sortListings(filtered);
      return sorted;
    },
  };
};